import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';

import { decryptResponse } from 'utils/token';

type GetPartnerShareOwnershipCertificateProps = {
  partnerId: string;
};

export const getPartnerShareOwnershipCertificate =
  ({ partnerId }: GetPartnerShareOwnershipCertificateProps) =>
  async (dispatch: Dispatch) => {
    const query = { params: { partnerId } };

    try {
      const { data } = await axiosV2.get(
        `/partners/sharesOwnershipCertificate`,
        query
      );

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
